export default __webpack_public_path__ + "static/media/alert-light.d1a41991.svg";